import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { RmLevelAdapter } from './dto/rm-level.adapter';
import { RmLevelController } from './rm-level-controller';
import { RmLevel } from './rm-level-entity';
import { RmLevelService } from './rm-level-service';


@Module({
  imports: [
    TypeOrmModule.forFeature([RmLevel]),
  ],
  controllers: [RmLevelController],
  providers: [RmLevelService,RmLevelAdapter,ApplicationExceptionHandler]
})
export class RmLevelModule {}
